import client from '../client'

export async function attachProfileImage({ image }) {
  const formData = new FormData()

  formData.set('File', image)

  return client(`${process.env.NEXT_PUBLIC_ACCOUNT_DOMAIN}/api/Accounts/AttachProfileImage`, {
    method: 'POST',
    body: formData,
  })
}
